import { createFileRoute } from "@tanstack/react-router";

import { ProductDetailPage } from "../../../../features/catalog/product-detail-page";

export const Route = createFileRoute("/_app/catalog/products/$id")({ component: ProductRoute });

function ProductRoute() {
  const { id } = Route.useParams();
  return <ProductDetailPage id={id} />;
}
